// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '맥널티제약',
  targetSheetName: '가나다순',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'no',
    '효능군',
    '제품명',
    '보험코드',
    '규격',
    '성분 · 함량',
    '보험약가',
    '수수료',
    '비고',
  ],
});
